import { CvSubmit } from '../cvSubmit';


export class CvsubmitSerializer {
    fromJson(json: any): CvSubmit {
   const data = new CvSubmit();
   data.id = json.id;
   data.cvSubmitted = json.cvSubmitted;
   data.cvShortListed = json.cvShortListed;
   data.submitDate = json.submitDate;
   data.jdId = json.jobDescription.id;
   data.jdName = json.jobDescription.name;
   data.recruiterId = json.recruiter.id;
   data.recruiterName = json.recruiter.firstName +" "+ json.recruiter.lastName;
   return data;
    }

    toJson(data: CvSubmit): any {
        return {
            id: data.id,
            cvSubmitted: data.cvSubmitted,
            cvShortListed : data.cvShortListed,
            submitDate: data.submitDate,
            jdId : data.jdId,
            jdName: data.jdName,
            recruiterId: data.recruiterId
        };
    }
}
